import enums from "./../enums";

const profile = (
	state = {
		gameHistory: {
			reports: [],
			count: 0,
			lastItem: null,
		},
		paymentHistory: {
			reports: [],
			count: 0,
			lastItem: null,
		},
		pendingHistory: {
			reports: [],
			count: 0,
			lastItem: null,
		},
		loading: false,
		inboxLoading: false,
		user: null,
		freespinHistory: [],
		notificationCounter: 0,
		inbox: {
			notifications: [],
		},
	},
	{ type, payload, msg }
) => {
	switch (type) {
		case enums.PROFILE_DATA: {
			return { ...state, user: payload };
		}
		case enums.PROFILE_LOADING: {
			return { ...state, loading: payload };
		}
		case enums.INBOX_LOADING: {
			return { ...state, inboxLoading: payload };
		}
		case enums.INBOX_LIST: {
			let inbox = { ...state.inbox };
			if (payload.isUpdate) {
				inbox = {
					...inbox,
					notifications: [...inbox.notifications, ...payload.notifications],
					offset: payload.offset,
				};
			} else if (payload.notifications && payload.notifications.length > 0) {
				inbox = payload;
			}
			return { ...state, inbox };
		}
		case enums.ADJUST_INBOX: {
			let inbox = { ...state.inbox };
			inbox.notifications = payload;
			return { ...state, inbox };
		}
		//GAME HISTORY
		case enums.PROFILE_GAME_HISTORY_LOADED: {
			return {
				...state,
				gameHistory: payload,
			};
		}
		case enums.PROFILE_GAME_HISTORY_LOADED_UPDATE: {
			return {
				...state,
				gameHistory: {
					count: state.gameHistory.count + payload.count,
					reports: [...state.gameHistory.reports, ...payload.reports],
					lastItem: payload.lastItem,
				},
			};
		}
		//PAYMENT HISTORY
		case enums.PROFILE_PAYMENT_HISTORY_LOADED: {
			let { wagering, reports } = payload;
			reports = reports.map((i) => {
				const walletId =
					i.walletContributions && i.walletContributions.length > 0
						? i.walletContributions[0].walletId
						: "no-wallet";
				if (wagering[walletId]) {
					return { ...i, wagering: wagering[walletId] };
				}
				return i;
			});
			return {
				...state,
				paymentHistory: { ...payload, reports },
			};
		}
		case enums.PROFILE_PAYMENT_HISTORY_LOADED_UPDATE: {
			let { wagering, reports } = payload;
			reports = reports.map((i) => {
				const walletId =
					i.walletContributions && i.walletContributions.length > 0
						? i.walletContributions[0].walletId
						: "no-wallet";
				if (wagering[walletId]) {
					return { ...i, wagering: wagering[walletId] };
				}
				return i;
			});
			return {
				...state,
				paymentHistory: {
					count: state.paymentHistory.count + payload.count,
					reports: [...state.paymentHistory.reports, ...reports],
					lastItem: payload.lastItem,
				},
			};
		}
		//PENDING HISTORY
		case enums.PROFILE_PENDING_HISTORY_LOADED: {
			return {
				...state,
				pendingHistory: payload,
			};
		}
		case enums.PROFILE_PENDING_HISTORY_LOADED_UPDATE: {
			return {
				...state,
				pendingHistory: {
					count: state.pendingHistory.count + payload.count,
					reports: [...state.pendingHistory.reports, ...payload.reports],
					lastItem: payload.lastItem,
				},
			};
		}
		//FREESPIN HISTORY
		case enums.PROFILE_FREESPIN_HISTORY_LOADED: {
			return {
				...state,
				freespinHistory: payload,
			};
		}
		case enums.NOTIFICATION_COUNTER: {
			return {
				...state,
				notificationCounter: payload,
			};
		}
		case enums.REDUCE_NOTIFICATION_COUNTER: {
			let { notificationCounter } = state;
			return {
				...state,
				notificationCounter: notificationCounter - 1 > 0 ? notificationCounter - 1 : 0,
			};
		}
		case enums.PROFILE_HISTORY_CALL_IN_PROGRESS: {
			return { ...state, loading: payload };
		}
		default:
			return { ...state };
	}
};

export default profile;
